import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { Link, Outlet } from "@remix-run/react";
import { Button } from "~/components/ui/button";

export default function Policy() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-r from-brand-100 to-brand-300">
      <Button variant="outline" asChild>
        <Link to="/" className="w-min ml-5 mt-5">
          <ArrowLeftIcon /> Back
        </Link>
      </Button>
      <div className="prose max-w-4xl w-full mx-auto my-12 p-6 bg-background rounded-md">
        <Outlet />
      </div>
    </div>
  );
}
